var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation1579331(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0014 1.99805C6.48663 1.99805 2 6.48474 2 11.9995C2 17.5143 6.48663 22.0009 12.0014 22.0009C17.5162 22.0009 22.0028 17.5143 22.0028 11.9995C22.0028 6.48474 17.5162 1.99805 12.0014 1.99805ZM12.0014 20.1824C7.48925 20.1824 3.81844 16.5116 3.81844 11.9995C3.81844 7.48742 7.48925 3.81648 12.0014 3.81648C16.5136 3.81648 20.1844 7.48742 20.1844 11.9995C20.1844 16.5116 16.5135 20.1824 12.0014 20.1824Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0011 6.24023C11.3328 6.24023 10.7891 6.78431 10.7891 7.45307C10.7891 8.12123 11.3328 8.66482 12.0011 8.66482C12.6694 8.66482 13.2132 8.12123 13.2132 7.45307C13.2132 6.78431 12.6694 6.24023 12.0011 6.24023Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.003 10.4863C11.5008 10.4863 11.0938 10.8934 11.0938 11.3955V16.8509C11.0938 17.353 11.5008 17.7601 12.003 17.7601C12.5051 17.7601 12.9122 17.353 12.9122 16.8509V11.3955C12.9122 10.8934 12.5051 10.4863 12.003 10.4863Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation1579331);
export default __webpack_public_path__ + "static/media/information_157933 1.55fb5f1168311e7779e155f73b8a63bd.svg";
export { ForwardRef as ReactComponent };